const cartorioKey = "@itbi-cartorio";
const tokenKey = "@itbi-token";

const funcionarioCartorioKey = "@itbi-cartorio-funcionario";
const funcionarioCartoriotokenKey = "@itbi-cartorio-funcionario-token";

const funcionarioPrefeituraKey = "@itbi-cartorio-prefeitura";
const funcionarioPrefeituraTokenKey = "@itbi-cartorio-prefeitura-token";

const prefeituraKey = "@itbi-prefeitura";
const prefeituratokenKey = "@itbi-prefeitura-token";

export {
  cartorioKey,
  tokenKey,
  funcionarioCartoriotokenKey,
  funcionarioCartorioKey,
  prefeituraKey,
  prefeituratokenKey,
  funcionarioPrefeituraTokenKey,
  funcionarioPrefeituraKey
};
